import React, { CSSProperties, FC, PropsWithChildren } from 'react'

import { ProfileHit } from 'common/constants'
import { WithDataName } from 'common/types'
import { StatusProfile } from 'common-constants/statusProfile'
import { RouterLink } from 'components/presentational/link'
import { createUserProfileUrl } from 'components/presentational/ProfileLink/function/createUserProfileUrl'
import { useAuthorized } from 'hooks/useAuthorized'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export enum TargetLink {
  blank = '_blank',
  self = '_self',
}

export const ProfileLink: FC<
  {
    id: number | undefined
    hit: ProfileHit | undefined
    scrollToTop?: boolean
    additionalPath?: string
    profileStatus?: StatusProfile
    target?: TargetLink
    style?: CSSProperties
    blank?: boolean
  } & WithDataName &
    PropsWithChildren
> = ({
  id,
  children,
  hit = 0,
  ['data-name']: dataName = 'link-profile-action',
  scrollToTop = true,
  additionalPath,
  profileStatus,
  style,
  target,
}) => {
  const authorized = useAuthorized()

  const { locale } = useShallowEqualSelector(
    ({ systemReducer: { locale } }) => ({ locale })
  )
  /**
   * Для неавторизованных не показываем hit см.:
   * https://redmine.mamba.ru/issues/114891
   */
  const url = createUserProfileUrl(
    id,
    authorized ? hit : undefined,
    authorized ? '' : locale,
    additionalPath,
    profileStatus
  )

  if (target) {
    return (
      <RouterLink
        to={url}
        data-name={dataName}
        scrollToTop={scrollToTop}
        target={target}
        style={style}
      >
        {children}
      </RouterLink>
    )
  }

  return (
    <RouterLink
      to={url}
      data-name={dataName}
      scrollToTop={scrollToTop}
      style={style}
    >
      {children}
    </RouterLink>
  )
}
